// Port of api/fuel/app/classes/filter/search/games/filters/query/rating/group/average.php
import F from 'offline/filter/constants'
import Util from 'offline/util'
import { rangeActive } from 'offline/filter/core/search/unit'
export default {
	name: 'rating.group.average',
	priority: 68,
	require: function(config, filter) {
		return config.ownerType !== F.OWNER_USER && rangeActive(filter.rating && filter.rating.group, 0, 10)
	},
	run: function(config, filter, data, query) {
		if (filter.rating.group.from > 0) {
			query.having('AVG(r.rating_value)', '>=', Util.adjustedRating(filter.rating.group.from))
		}
		if (filter.rating.group.to < 10) {
			query.having('AVG(r.rating_value)', '<=', Util.adjustedRating(filter.rating.group.to, true))
		}
	}
}
